import React, { useContext } from 'react';
import DropdownMenuDesktop from 'components/dropdownMenu/dropdownMenuDesktop';
import { UiContext } from 'uiContext';
import { DataStore } from 'mobx/dataStore';
import DropdownMenuMobile from 'components/dropdownMenu/dropdownMenuMobile';
import DropdownMenuTablet from 'components/dropdownMenu/dropdownMenuTablet';

export type DropdownMenuProps = {
  initialIsOpen: boolean;
  data: DataStore.Data;
};

export default function DropdownMenu(props: DropdownMenuProps) {
  const { isMobile, isTablet } = useContext(UiContext);

  return isMobile ? (
    <DropdownMenuMobile {...props}></DropdownMenuMobile>
  ) : isTablet ? (
    <DropdownMenuTablet {...props}></DropdownMenuTablet>
  ) : (
    <DropdownMenuDesktop {...props}></DropdownMenuDesktop>
  );
}
